export const ErrorMessages = {
  Senha: 'A senha do certificado informada está incorreta.',
  SenhaContador: 'A senha do certificado do contador informada está incorreta.',
};
